import React from 'react';
import { getStored, getText } from '../util/translations';
import { getInternalAuth, getParticipantAuth } from '../util/authSession';

const Processando = ({ idioma = 'portugues' }) => {
    let temTraducao = !!getStored()?.codigo
    let ehConvidado = false;
    try {
        ehConvidado = !getInternalAuth().token;
    } catch (e) {
        ehConvidado = false;
    }
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 100, // abaixo da navbar (102) e da access-sidebar (103) — mantém nav/sidebar visíveis e utilizáveis durante o load
            }}
        >
            <div className="modal-dialog" style={{ margin: 0 }}>
                <div className="modal-content">
                    <div className="modal-body d-flex align-items-center gap-3 px-4 py-3">
                        <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem', flexShrink: 0 }} />
                        <span>{
                            idioma === "both" && (!temTraducao) ?
                                `${getText('loading', 'portugues')} (${getText('loading', 'ingles')})`
                                :
                                (!ehConvidado ? "Carregando..." :
                                getText('loading', idioma))
                        }</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Processando;
